export const SET_PUBLISHING = 'SET_PUBLISHING'
export const SET_POST_SIDEBAR_OPEN = 'SET_POST_SIDEBAR_OPEN'
export const SET_SAVING_DRAFT = 'SET_SAVING_DRAFT'
export const SET_POST_DATA = 'SET_POST_DATA'
